import pushGA4 from '../utils/pushGA4';
import pushYM from '../utils/pushYM';
// Загрузка блоков //
export var analyticsMainPageBlockLoaded = function (_a) {
    var step = _a.step, items = _a.items;
    pushGA4('view_promotion', 'portal', 'main', {
        step: step,
        promotion_name: 'load_main_offers',
        items: items,
    });
    pushYM({
        goalParams: {
            event_name: 'view_promotion',
            application: 'portal',
            flow: 'main',
            step: step,
            promotion_name: 'load_main_offers',
            items: items,
        },
    });
};
// Просмотр элементов главной //
export var analyticsMainPageBlockShown = function (_a) {
    var step = _a.step, ux = _a.ux, items = _a.items;
    pushGA4('view_promotion', 'portal', 'main', {
        step: step,
        promotion_name: 'view_main_offers',
        ux_ui: ux,
        items: items,
    });
    pushYM({
        goalParams: {
            event_name: 'view_promotion',
            application: 'portal',
            flow: 'main',
            step: step,
            promotion_name: 'view_main_offers',
            ux_ui: ux,
            items: items,
        },
    });
};
// Клик на элемент главной //
export var analyticsMainPageBlockClick = function (_a) {
    var step = _a.step, items = _a.items;
    pushGA4('select_promotion', 'portal', 'main', {
        step: step,
        promotion_name: 'click_main_offers',
        items: items,
    });
    pushYM({
        goalParams: {
            event_name: 'select_promotion',
            application: 'portal',
            flow: 'main',
            step: step,
            promotion_name: 'click_main_offers',
            items: items,
        },
    });
};
// События блока Shop на главной странице //
// Загрузка блока//
export var analyticsMainPageShopLoaded = function (_a) {
    var items = _a.items;
    pushGA4('view_item_list', 'portal', 'main', {
        step: 'shop',
        item_list_name: 'load_offer',
        items: items,
    });
    pushYM({
        goalParams: {
            event_name: 'view_item_list',
            application: 'portal',
            flow: 'main',
            step: 'shop',
            item_list_name: 'load_offer',
            items: items,
        },
    });
};
// Пользователь увидел товары//
export var analyticsMainPageShopShown = function (_a) {
    var items = _a.items;
    pushGA4('view_item_list', 'portal', 'main', {
        step: 'shop',
        item_list_name: 'view_item_list',
        items: items,
    });
    pushYM({
        goalParams: {
            event_name: 'view_item_list',
            application: 'portal',
            flow: 'main',
            step: 'shop',
            item_list_name: 'view_item_list',
            items: items,
        },
    });
};
// Пользователь кликнул на товар //
export var analyticsMainPageShopClick = function (_a) {
    var items = _a.items;
    pushGA4('select_item', 'portal', 'main', {
        step: 'shop',
        items: items,
    });
    pushYM({
        goalParams: {
            event_name: 'select_item',
            application: 'portal',
            flow: 'main',
            step: 'shop',
            items: items,
        },
    });
};
// Клик на кнопку в шопе "Смотреть все"//
export var analyticsMainPageShopClickShowMore = function () {
    pushGA4('click_cta', 'portal', 'main', {
        step: 'shop',
        result: 'click_see_all',
    });
    pushYM({
        goalParams: {
            event_name: 'click_cta',
            application: 'portal',
            flow: 'main',
            step: 'shop',
            result: 'click_see_all'
        },
    });
};
// блок Helpcenter на главной странице //
export var analyticsMainHelpcenterClickMore = function () {
    pushGA4('click_cta', 'portal', 'main', {
        step: 'helpcenter',
        result: 'go_to_helpcenter',
    });
    pushYM({
        goalParams: {
            event_name: 'click_cta',
            application: 'portal',
            flow: 'main',
            step: 'helpcenter',
            result: 'go_to_helpcenter',
        },
    });
};
export var analyticsMainHelpcenterClickArticle = function (_a) {
    var item_category = _a.item_category, item_category2 = _a.item_category2, item_id = _a.item_id;
    pushGA4('click_cta', 'portal', 'main', {
        step: 'helpcenter',
        result: 'go_to_helpcenter_article',
        item_category: item_category,
        item_category2: item_category2,
        item_id: item_id
    });
    pushYM({
        goalParams: {
            event_name: 'click_cta',
            application: 'portal',
            flow: 'main',
            step: 'helpcenter',
            result: 'go_to_helpcenter_article',
            item_category: item_category,
            item_category2: item_category2,
            item_id: item_id,
        },
    });
};
